import type { TranslationTree } from '../../types';

export const admin: TranslationTree = {
  admin: {
    hero: {
      badge: 'Admin workspace',
      title: 'Manage every access with ease',
      description:
        'Create accounts, assign modules, and synchronize your tools in just a few clicks. This hub keeps you in control of your ToolLife platform.',
    },
    tabs: {
      users: 'Users',
      tools: 'Tools',
    },
    sections: {
      userCreation: {
        title: 'Create a new user account',
        description:
          'Fill in the required information and choose the modules this user can access.',
      },
      toolCreation: {
        title: 'Register a new tool',
        description:
          'Add a tool to the traceability database so it becomes available across the ToolLife ecosystem.',
      },
    },
    registerForm: {
      fields: {
        firstName: {
          label: 'First name',
          placeholder: 'e.g. Jeanne',
        },
        lastName: {
          label: 'Last name',
          placeholder: 'e.g. Martin',
        },
        email: {
          label: 'Email address',
          placeholder: 'firstname.lastname@company.com',
        },
        company: {
          label: 'Company',
          placeholder: 'Company name',
        },
        password: {
          label: 'Password',
          placeholder: '••••••••',
        },
        confirmPassword: {
          label: 'Confirm password',
          placeholder: '••••••••',
        },
      },
      role: {
        title: 'Assigned role',
        description: 'Enable this option to grant administrator privileges to the account.',
        adminLabel: 'Administrator',
      },
      modules: {
        title: 'Accessible modules',
        options: {
          traceability: {
            label: 'Traceability',
            description: 'Real-time tracking of production submissions.',
          },
          machineLearning: {
            label: 'Machine Learning',
            description: 'Predictive models to anticipate anomalies.',
          },
          analytics: {
            label: 'Analytics',
            description: 'Advanced statistics and tailored dashboards.',
          },
        },
      },
      submit: 'Create account',
      success: 'User added successfully!',
      errors: {
        passwordMismatch: 'Passwords do not match',
        default: 'An error occurred',
      },
    },
    registerToolForm: {
      fields: {
        toolId: {
          label: 'Tool identifier',
          placeholder: 'e.g. TL-4587',
        },
        reference: {
          label: 'Internal reference',
          placeholder: 'Manufacturer reference',
        },
        company: {
          label: 'Associated company',
          placeholder: 'Company name',
        },
      },
      info: 'Tools registered here are immediately available for ToolLife traceability and analytics.',
      submit: 'Add tool',
      success: 'Tool added successfully!',
      errors: {
        default: 'An error occurred',
      },
    },
    permissionError: {
      title: 'Page not available',
      backHome: 'Back to home',
    },
  },
};
